<template>
    <img src="@assets/images/zs.jpg">
</template>
<script>
export default {
    name:'Zhaos'
}
</script>